import React from "react";

const GaleriaFacebook = () => {

  return (

    <div style={{marginTop:"40px"}}>

      <div className="elfsight-app-1d3e3a6c-1e18-471b-8275-d685f1a261ce"></div>

    </div>

  );

};

export default GaleriaFacebook;
